export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const SELECT_ENTITY_TYPE = 'SELECT_ENTITY_TYPE';

export const SEARCH_MUSIC = 'SEARCH_MUSIC';
export const SEARCH_MUSIC_FAIL = 'SEARCH_MUSIC_FAIL';
export const SEARCH_MUSIC_SUCCESS = 'SEARCH_MUSIC_SUCCESS';

export const SEARCH_ARTISTS = 'SEARCH_ARTISTS';
export const SEARCH_ARTISTS_FAIL = 'SEARCH_ARTISTS_FAIL';
export const SEARCH_ARTISTS_SUCCESS = 'SEARCH_ARTISTS_SUCCESS';

export const SEARCH_ALBUMS = 'SEARCH_ALBUMS';
export const SEARCH_ALBUMS_FAIL = 'SEARCH_ALBUMS_FAIL';
export const SEARCH_ALBUMS_SUCCESS = 'SEARCH_ALBUMS_SUCCESS';

export const SEARCH_SONGS = 'SEARCH_SONGS';
export const SEARCH_SONGS_FAIL = 'SEARCH_SONGS_FAIL';
export const SEARCH_SONGS_SUCCESS = 'SEARCH_SONGS_SUCCESS';

export const SELECT_ARTIST = 'SELECT_ARTIST';
export const SELECT_ALBUM = 'SELECT_ALBUM';
export const SELECT_SONG = 'SELECT_SONG';
export const NEXT_SONG = 'NEXT_SONG';
export const PREV_SONG = 'PREV_SONG';
export const LOADING_MUSIC = 'LOADING_MUSIC';